import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../../buttons/SystemCustomButton";
import {kCoursesTexts} from "../../../constants/texts";
import {kButtonStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import {CircularProgress} from "@mui/material";

export default function DetailedCourseBottomBar({ isFlashLoading,
                                                  fetchFlashQuestions,
                                                  // ---- Exerciser
                                                  hasExerciser,
                                                  isExerciserLoading,
                                                  fetchExerciserProblem }) {
    // Used in SingleKnowledgeScreen to display modal
    // bottom bar with both back and launch flash action

    // BUILD
    return (
        <div className={"w-full border-t-1 border-greyLight5"}>
            <div className={"flex space-x-16 p-16"}>
                {hasExerciser
                    ? <SystemSecondaryCustomButton
                        label={kCoursesTexts.launchFlashShort}
                        isDisabled={false}
                        isLoading={isFlashLoading}
                        loaderComponent={<CircularProgress size={"24px"}
                                                           style={{'color' : 'white'}} />}
                        isFullWidth={true}
                        icon={kSystemIcons.bolt}
                        sizeStyle={kButtonStyles.largeButtonStyle}
                        extraClass={"w-full"}
                        onButtonClick={fetchFlashQuestions} />
                    : <SystemPrimaryCustomButton
                        label={kCoursesTexts.launchFlashLong}
                        isDisabled={false}
                        isLoading={isFlashLoading}
                        loaderComponent={<CircularProgress size={"24px"}
                                                           style={{'color' : 'white'}} />}
                        isFullWidth={true}
                        sizeStyle={kButtonStyles.largeButtonStyle}
                        extraClass={"w-full"}
                        onButtonClick={fetchFlashQuestions} /> }
                {hasExerciser && (
                    <SystemPrimaryCustomButton
                        label={kCoursesTexts.launchExerciser}
                        isDisabled={false}
                        isLoading={isExerciserLoading}
                        loaderComponent={<CircularProgress size={"24px"}
                                                           style={{'color' : 'white'}} />}
                        isFullWidth={true}
                        icon={kSystemIcons.gear}
                        sizeStyle={kButtonStyles.largeButtonStyle}
                        extraClass={"w-full"}
                        onButtonClick={fetchExerciserProblem} />
                )}
            </div>
        </div>
    );
}